(function () {
  var mq = window.matchMedia('(max-width: 767.98px)');

  function needsClamp(root) {
    var inner = root.querySelector('.collection-description-expandable__inner');
    if (!inner) return false;
    return inner.scrollHeight > inner.clientHeight + 1;
  }

  function update(root) {
    var inner = root.querySelector('.collection-description-expandable__inner');
    var btnMore = root.querySelector('[data-action="expand"]');
    var btnLess = root.querySelector('[data-action="collapse"]');
    if (!inner || !btnMore || !btnLess) return;

    if (!mq.matches) {
      root.classList.remove('is-expanded');
      btnMore.hidden = true;
      btnLess.hidden = true;
      btnMore.setAttribute('aria-hidden', 'true');
      btnLess.setAttribute('aria-hidden', 'true');
      btnMore.setAttribute('aria-expanded', 'false');
      btnLess.setAttribute('aria-expanded', 'false');
      return;
    }

    if (root.classList.contains('is-expanded')) {
      btnMore.hidden = true;
      btnLess.hidden = false;
      btnMore.setAttribute('aria-hidden', 'true');
      btnLess.setAttribute('aria-hidden', 'false');
      btnMore.removeAttribute('aria-expanded');
      btnLess.setAttribute('aria-expanded', 'true');
      return;
    }

    if (needsClamp(root)) {
      btnMore.hidden = false;
      btnLess.hidden = true;
      btnMore.setAttribute('aria-hidden', 'false');
      btnLess.setAttribute('aria-hidden', 'true');
      btnMore.setAttribute('aria-expanded', 'false');
      btnLess.removeAttribute('aria-expanded');
    } else {
      btnMore.hidden = true;
      btnLess.hidden = true;
      btnMore.setAttribute('aria-hidden', 'true');
      btnLess.setAttribute('aria-hidden', 'true');
      btnMore.setAttribute('aria-expanded', 'false');
      btnLess.setAttribute('aria-expanded', 'false');
    }
  }

  function bind(root) {
    var btnMore = root.querySelector('[data-action="expand"]');
    var btnLess = root.querySelector('[data-action="collapse"]');
    if (!btnMore || !btnLess) return;

    btnMore.addEventListener('click', function () {
      root.classList.add('is-expanded');
      update(root);
    });
    btnLess.addEventListener('click', function () {
      root.classList.remove('is-expanded');
      update(root);
    });
  }

  function init() {
    document.querySelectorAll('[data-collection-description-expandable]').forEach(function (root) {
      bind(root);
      update(root);
    });
  }

  var debounce;
  function onResize() {
    clearTimeout(debounce);
    debounce = setTimeout(function () {
      document.querySelectorAll('[data-collection-description-expandable]').forEach(update);
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('resize', onResize);
  if (mq.addEventListener) {
    mq.addEventListener('change', onResize);
  } else if (mq.addListener) {
    mq.addListener(onResize);
  }
})();
